export const excludeOnCallShifts = (shifts = []) => {
    if (!Array.isArray(shifts)) {
        return [];
    }

    return shifts.filter(shift => !shift?.isOnCall);
};

export const sumNonOnCallShiftHours = (shifts = []) => {
    return excludeOnCallShifts(shifts).reduce(
        (sum, shift) => sum + (Number(shift?.shiftHours) || 0),
        0
    );
};
